// Devil Fruit Quiz Game Configuration
// Control ALL game settings, visuals, and text from this ONE file

const devilFruitGameConfig = {
// === GAME SETTINGS ===
maxQuestions: 15,
    maxPasses: 6,
    timePerQuestion: 15, // seconds
    
    // === VISUAL THEME ===
    theme: {
      // Background colors (dark mysterious theme)
      primaryColor: '#1a0033',      // Deep purple
      secondaryColor: '#4d0099',    // Medium purple
      accentColor: '#ff00ff',       // Magenta
      
      // Text colors
      titleColor: '#ffffff',
      subtitleColor: '#cc99ff',
      questionColor: '#ffffff',
      
      // Button colors
      buttonPrimary: '#7700ff',
      buttonHover: '#9933ff',
      correctColor: '#00ff00',
      incorrectColor: '#ff0000',
      
      // Fonts
      titleFont: '2.5rem',
      questionFont: '1.5rem',
      answerFont: '1.1rem',
    },
    // === GAME IMAGES ===
  images: {
    backgroundImage: require('../assets/images/seaonepiece.jpg'),
    introImage: '/GAME START.jpg',
    gameOverBackground: '/game-over-background.jpg',
  },
    
// === GAME SOUNDS ===
sounds: {
    backgroundMusic: null, // No background music
    correctSound: '/audio/correct-ans.mp3',
    incorrectSound: '/audio/incorrect-yasashi.mp3',
    gameOverSound: '/audio/game-over-show.mp3',
  },
    // === GAME TEXT ===
    text: {
      introTitle: '🍎 DEVIL FRUIT QUIZ 🍎',
      introSubtitle: 'Test your knowledge of Devil Fruit powers!',
      startButtonText: 'Start Quiz',
      questionPrefix: "What's their Devil Fruit power?",
      passButtonText: 'Pass',
      restartButtonText: 'Restart Game',
      nextButtonText: 'Next Question',
      correctFeedback: 'Correct! 🎉',
      incorrectFeedback: 'Incorrect! The correct answer is:',
      gameOverTitle: 'Quiz Complete!',
      gameOverSubtext: 'Your Results',
      restartGameOverText: 'Play Again',
    },
    
// === DEVIL FRUIT DATA ===
  // Characters WITH Devil Fruits
  devilFruits: {
    // STRAW HAT CREW - WITH FRUITS
    'Monkey D. Luffy': 'Gomu Gomu no Mi (Rubber)',
    'Tony Tony Chopper': 'Hito Hito no Mi (Human)',
    'Nico Robin': 'Hana Hana no Mi (Flower)',
    'Brook': 'Yomi Yomi no Mi (Revive)',
    
    // STRAW HAT CREW - NO FRUITS
    'Roronoa Zoro': 'No Devil Fruit',
    'Nami': 'No Devil Fruit',
    'Usopp': 'No Devil Fruit',
    'Sanji': 'No Devil Fruit',
    'Franky': 'No Devil Fruit',
    
    // ALLIES - WITH FRUITS
    'Portgas D. Ace': 'Mera Mera no Mi (Fire)',
    'Boa Hancock': 'Mero Mero no Mi (Love)',
    'Trafalgar Law': 'Ope Ope no Mi (Surgery)',
    'Sabo': 'Mera Mera no Mi (Fire)',
    
    // ALLIES - NO FRUITS
    'Shanks': 'No Devil Fruit',
    'Jinbe': 'No Devil Fruit',
    'Nefertari Vivi': 'No Devil Fruit',
    'Dracule Mihawk': 'No Devil Fruit',
    
    // VILLAINS - WITH FRUITS
    'Donquixote Doflamingo': 'Ito Ito no Mi (String)',
    'Buggy': 'Bara Bara no Mi (Chop)',
    'Crocodile': 'Suna Suna no Mi (Sand)',
    'Blackbeard': 'Yami Yami no Mi (Darkness)',
    'Charlotte Linlin': 'Soul Soul no Mi (Soul)',
    'Akainu': 'Magu Magu no Mi (Magma)',
    'Rob Lucci': 'Neko Neko no Mi (Leopard)',
    'Enel': 'Goro Goro no Mi (Lightning)',
    'Smoker': 'Moku Moku no Mi (Smoke)',
    'Bartolomeo': 'Bari Bari no Mi (Barrier)',
    'Caesar Clown': 'Gasu Gasu no Mi (Gas)',
    'Kizaru': 'Pika Pika no Mi (Light)',
    'Aokiji': 'Hie Hie no Mi (Ice)',
    'Marco': 'Tori Tori no Mi: Phoenix',
    'Kaku': 'Ushi Ushi no Mi: Giraffe',
    'Alvida': 'Sube Sube no Mi (Slip)',
  },
    
    // === WRONG ANSWERS POOL ===
    wrongAnswers: [
      'Gomu Gomu no Mi (Rubber)',
      'Mera Mera no Mi (Fire)',
      'Hana Hana no Mi (Flower)',
      'Yami Yami no Mi (Darkness)',
      'Goro Goro no Mi (Lightning)',
      'Hie Hie no Mi (Ice)',
      'Magu Magu no Mi (Magma)',
      'Pika Pika no Mi (Light)',
      'Ope Ope no Mi (Surgery)',
      'Suna Suna no Mi (Sand)',
      'Moku Moku no Mi (Smoke)',
      'Ito Ito no Mi (String)',
      'Bara Bara no Mi (Chop)',
      'Gasu Gasu no Mi (Gas)',
      'Bari Bari no Mi (Barrier)',
      'No Devil Fruit',
    ],
  };
  
  export default devilFruitGameConfig;